import API from "../../routes/api.routes";
import { ApiMananger } from "../apiMananger";

export const epreuveApi = ApiMananger.injectEndpoints({
  endpoints: (build) => ({
    getEpreuves: build.query({
      query: () => API.EPREUVES_API.GETALL(),
      providesTags: ["Epreuves"],
    }),
    getFristEpreuvesCoach: build.query({
      query: ({ limit }) =>
        limit ? `epreuves/?limit=${limit}&offset=0` : "epreuves/",
      providesTags: ["Epreuves"],
    }),
    getEpreuve: build.query({
      query: (id) => API.EPREUVES_API.GET(id),
      providesTags: ["Epreuves"],
    }),
    addEpreuves: build.mutation({
      query({ body, token }) {
        return {
          url: API.EPREUVES_API.ADD(),
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "X-CSRFToken": token,
          },
          body,
        };
      },
      invalidatesTags: ["Epreuves"],
    }),
    EditEpreuves: build.mutation({
      query({ body, token }) {
        return {
          url: API.EPREUVES_API.EDIT(body?.id),
          method: "PUT",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "X-CSRFToken": token,
          },
          body,
        };
      },
      invalidatesTags: ["Epreuves"],
    }),
    ArchiveEpreuve: build.mutation({
      query({ body, token }) {
        return {
          url: API.EPREUVES_API.EDIT(body?.id),
          method: "PUT",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "X-CSRFToken": token,
          },
          body,
        };
      },
      invalidatesTags: ["Epreuves"],
    }),
    deleteEpreuves: build.mutation({
      query(id) {
        return {
          // url: API.EPREUVES_API.DELETE(id),
          url: `epreuves/diagnostic/delete/${id}/`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["Epreuves"],
    }),
    // Audio pré-enregistré : un fichier par position (aligné sur correction_dp).
    // L'admin upload après la sauvegarde JSON de l'épreuve ; l'ID vient du PUT/POST.
    uploadEpreuveAudio: build.mutation({
      query({ epreuveId, position, file }) {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("position", position);
        return {
          url: `epreuves/${epreuveId}/audio/`,
          method: "POST",
          body: formData,
        };
      },
      invalidatesTags: ["Epreuves"],
    }),
    deleteEpreuveAudio: build.mutation({
      query({ epreuveId, position }) {
        return {
          url: `epreuves/${epreuveId}/audio/?position=${position}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["Epreuves"],
    }),
  }),
});

export const {
  useGetEpreuvesQuery,
  useGetFristEpreuvesCoachQuery,
  useAddEpreuvesMutation,
  useEditEpreuvesMutation,
  useDeleteEpreuvesMutation,
  useArchiveEpreuveMutation,
  useGetEpreuveQuery,
  useUploadEpreuveAudioMutation,
  useDeleteEpreuveAudioMutation,
} = epreuveApi;
